import { render, staticRenderFns } from "./BasicSelect.vue?vue&type=template&id=3521db32&scoped=true"
import script from "./BasicSelect.vue?vue&type=script&lang=js"
export * from "./BasicSelect.vue?vue&type=script&lang=js"
import style0 from "./BasicSelect.vue?vue&type=style&index=0&id=3521db32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3521db32",
  null
  
)

export default component.exports